module.exports = __webpack_public_path__ + "media/images/prediction/special/move/img_greeting_move-78b59d329c8ebe48a37bf825fd20cc2f.jpg";